export function
openItemDetailWindow(itemSku) {
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute(
    'action',
    'https://www.amway.co.kr/share/ajax/product/detail',
  );
  form.setAttribute('target', 'item_detail');

  const field = document.createElement('input');
  field.setAttribute('type', 'hidden');
  field.setAttribute('name', 'code');
  field.setAttribute('value', itemSku);

  form.appendChild(field);
  document.body.appendChild(form);

  window.open('', 'item_detail');
  form.submit();
  form.remove();
}

export function parseMobileNumber(str) {
  switch (str.length) {
    case 7:
      return [str.substr(0, 3), str.substr(3, 4)];
    case 8:
      return [str.substr(0, 4), str.substr(4, 4)];
    case 10:
      return [str.substr(0, 3), str.substr(3, 3), str.substr(6, 4)];
    case 11:
      return [str.substr(0, 3), str.substr(3, 4), str.substr(7, 4)];
    default:
      console.warn('wrong mobile number format!', str);
      return [str.substr(0, 4), str.substr(4)];
  }
}

export function openNewWindow(url, windowName) {
  window.open(url, windowName);
}

export function log(ctx, ...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c[${ctx}]`, 'color:#008fc5', ...args);
  }
}

export function thousandSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function validateJwt(token) {
  if (!token) {
    log('auth::jwt', 'EMPTY_TOKEN');
    return null;
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      log('auth::jwt', 'INVALID_STRUCTURE');
      return null;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    const payload = JSON.parse(jsonPayload);

    const now = Math.floor(Date.now() / 1000);
    if (!payload.exp || payload.exp < now) {
      log('auth::jwt', 'EXPIRED');
      return null;
    }

    return payload;
  } catch (e) {
    log('auth::jwt', 'EXCEPTION', e.message);
    return null;
  }
}

export default {
  openItemDetailWindow,
  openNewWindow,
  log,
  parseMobileNumber,
  thousandSeparator,
  validateJwt
};



// WEBPACK FOOTER //
// ./src/utils/common.js